$(function () {
  // メニューの財布カテゴリを開いた状態にする
  if($('.js-accordion-btn').text().includes('カテゴリから探す')) {
    const $this = $(".js-accordion-btn:contains('カテゴリから探す')");
    $this.addClass('is-open');
    $this.next().slideToggle();
  }
})
